var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.19 7.8-2.83 2.84m4.49-7.32-.78.78c-.07.07-.1.1-.14.12a.5.5 0 0 1-.1.06l-.17.04-1.83.37c-.48.1-.72.14-.83.26a.5.5 0 0 0-.12.4c.02.17.2.34.54.69l3.54 3.54c.34.34.51.51.68.54a.5.5 0 0 0 .4-.12c.13-.11.17-.35.27-.83l.37-1.83c.01-.09.02-.13.04-.17a.5.5 0 0 1 .05-.1c.03-.04.06-.08.13-.14l.78-.78.08-.08a.5.5 0 0 1 .06-.04l.1-.05 1.25-.53c.37-.16.55-.24.63-.36a.5.5 0 0 0 .07-.38c-.03-.15-.17-.29-.45-.57L7.85 1.57c-.28-.28-.42-.42-.57-.45a.5.5 0 0 0-.37.07c-.12.09-.2.27-.36.63l-.53 1.25-.05.1a.5.5 0 0 1-.04.07l-.08.08Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.7a2fad658051e870c9f56d02e708cfb7.svg";
export { ForwardRef as ReactComponent };